import "core-js/modules/es.array.push.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, unref as _unref } from "vue";
const _hoisted_1 = {
  class: "page",
  id: "page"
};
const _hoisted_2 = {
  class: "section-md bg-transparent"
};
const _hoisted_3 = {
  class: "container"
};
const _hoisted_4 = {
  class: "row row-30 row-xl-20 row-xxl-100"
};
const _hoisted_5 = ["onClick"];
const _hoisted_6 = {
  class: "post-media"
};
const _hoisted_7 = {
  key: 1,
  style: {
    "display": "flex",
    "align-items": "center",
    "justify-content": "center",
    "width": "370px",
    "height": "257px"
  }
};
const _hoisted_8 = {
  class: "post-content"
};
const _hoisted_9 = {
  class: "post-tags group-5"
};
const _hoisted_10 = {
  class: "post-tag"
};
const _hoisted_11 = {
  class: "post-title text-divider",
  style: {
    "height": "60px",
    "display": "flex",
    "align-items": "center"
  }
};
const _hoisted_12 = {
  href: "#"
};
const _hoisted_13 = {
  class: "line-2"
};
const _hoisted_14 = {
  class: "post-date"
};
const _hoisted_15 = {
  key: 0,
  class: "text-primary text-center loading-indicator"
};
const _hoisted_16 = {
  key: 1,
  class: "text-primary text-center no-more-data"
};
import { onMounted, onBeforeUnmount, ref, computed, nextTick } from 'vue';
import { newsList as newsListHttp } from '@/api/news';
import { bannerList as bannerListHttp } from '@/api/home';
import { useThrottleFn } from '@vueuse/core';
import dayjs from 'dayjs';
import { useRouter } from 'vue-router';
export default {
  __name: 'our-cases',
  setup(__props) {
    const path = computed(() => {
      return process.env.VUE_APP_BASE_ADDRESS;
    });

    // 顶部图片
    const bg = ref('');
    const getBanner = async () => {
      const data = await bannerListHttp({
        type: 'news'
      });
      if (data?.length > 0) {
        for (const item of data) {
          if (!item.src.startsWith('http')) item.src = path.value + item.src;
        }
        bg.value = data[0]?.src;
      }
    };

    // 新闻
    const newsList = ref([]);
    const loading = ref(false); // 加载状态标志
    const noMoreData = ref(false); // 是否没有更多数据

    const getData = async (page = 1) => {
      if (loading.value || noMoreData.value) return; // 如果已经在加载中，直接返回
      loading.value = true; // 设置加载状态为 true
      try {
        const {
          list,
          total
        } = await newsListHttp({
          page,
          pageSize: 20
        });
        // 没有更多数据了
        noMoreData.value = list.length < 20;
        if (list?.length > 0) {
          for (const item of list) {
            if (!item?.thumb) continue;
            if (!item.thumb.startsWith('http')) item.thumb = path.value + item.thumb;
          }
          newsList.value.push(...list);
        }
      } catch (error) {
        console.error('加载数据失败:', error);
      } finally {
        loading.value = false;
      }
    };
    const scrollbarRef = ref(null);
    const scrollFn = useThrottleFn(e => {
      const {
        clientHeight,
        scrollHeight,
        scrollTop
      } = scrollbarRef.value?.wrapRef;
      // console.log(scrollHeight, clientHeight, scrollTop, '***clientHeight***');
      if (scrollbarRef.value && !loading.value && !noMoreData.value) {
        // 计算距离底部的距离
        const distanceToBottom = scrollHeight - clientHeight - scrollTop;
        // console.log(distanceToBottom, '***计算距离底部的距离***');
        if (distanceToBottom <= 1500) {
          // console.log('触发加载更多数据', newsList.value.length, Math.ceil(newsList.value.length) / 20);
          // 触发加载更多数据的函数
          getData(Math.ceil(newsList.value.length) / 20 + 1);
        }
      }
      // 获取滚动条高度
      // console.log(e, '***5566665***', e.scrollTop);
    });
    const handleScroll = useThrottleFn(e => {
      const scrollTop = window.scrollY || document.documentElement.scrollTop || document.body.scrollTop || 0;
      const clientHeight = document.documentElement.clientHeight;
      const scrollHeight = document.documentElement.scrollHeight;
      // console.log(distanceToBottom, '***计算距离底部的距离***');
      const distanceToBottom = scrollHeight - clientHeight - scrollTop;

      // console.log('距离底部的距离distanceToBottom', distanceToBottom);

      if (!loading.value && !noMoreData.value) {
        if (distanceToBottom <= 1500) {
          // 触发加载更多数据的函数
          getData(Math.ceil(newsList.value.length) / 20 + 1);
        }
      }
    });
    const router = useRouter();
    const goDetail = (id, is_wexin = null, wx_url = null) => {
      if (is_wexin === 1 && wx_url) {
        window.open(wx_url);
        return;
      }
      router.push({
        path: '/case-page',
        query: {
          id
        }
      });
    };
    onMounted(async () => {
      getBanner();
      nextTick(() => {
        getData();
        document.addEventListener('scroll', handleScroll);
      });
    });
    onBeforeUnmount(() => {
      document.removeEventListener('scroll', handleScroll);
    });
    return (_ctx, _cache) => {
      const _component_Preload = _resolveComponent("Preload");
      const _component_Header = _resolveComponent("Header");
      const _component_el_image = _resolveComponent("el-image");
      const _component_Footer = _resolveComponent("Footer");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_Preload), _createElementVNode("div", _hoisted_1, [_createVNode(_component_Header, {
        title: "冀华洞见",
        bg: bg.value
      }, null, 8, ["bg"]), _createElementVNode("section", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(newsList.value, item => {
        return _openBlock(), _createElementBlock("div", {
          class: "col-md-4",
          key: item.id
        }, [_createElementVNode("div", {
          class: "post post-shadow",
          onClick: $event => goDetail(item.id, item?.is_weixin, item?.wx_url)
        }, [_createElementVNode("div", _hoisted_6, [item?.thumb ? (_openBlock(), _createBlock(_component_el_image, {
          key: 0,
          fit: "contain",
          src: item.thumb,
          style: {
            "width": "370px",
            "height": "257px"
          }
        }, {
          error: _withCtx(() => _cache[0] || (_cache[0] = [_createElementVNode("div", {
            style: {
              "display": "flex",
              "align-items": "center",
              "justify-content": "center",
              "width": "370px",
              "height": "257px"
            }
          }, [_createElementVNode("img", {
            src: "/images/logo2.png",
            alt: "",
            style: {
              "width": "120px"
            }
          })], -1)])),
          _: 2
        }, 1032, ["src"])) : (_openBlock(), _createElementBlock("div", _hoisted_7, _cache[1] || (_cache[1] = [_createElementVNode("img", {
          src: "/images/logo2.png",
          alt: "",
          style: {
            "width": "120px"
          }
        }, null, -1)]))), _cache[2] || (_cache[2] = _createElementVNode("div", {
          class: "post-hover-btn"
        }, "详情", -1))]), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_createElementVNode("span", _hoisted_10, _toDisplayString(item?.news_type?.name), 1)]), _createElementVNode("h5", _hoisted_11, [_createElementVNode("a", _hoisted_12, [_createElementVNode("div", _hoisted_13, _toDisplayString(item.title), 1)])]), _createElementVNode("h5", _hoisted_14, _toDisplayString(_unref(dayjs)(item.date || item.createdAt).format('YYYY-MM-DD')), 1)])], 8, _hoisted_5)]);
      }), 128))])])]), loading.value ? (_openBlock(), _createElementBlock("div", _hoisted_15, "加载中...")) : _createCommentVNode("", true), noMoreData.value ? (_openBlock(), _createElementBlock("div", _hoisted_16, "没有更多数据了")) : _createCommentVNode("", true), _createVNode(_component_Footer)])], 64);
    };
  }
};